import { api } from "@/services/api";

export default {
    data: () => ({
        loading: true
    }),
    props: {
        id: {},
        preview: {
            default: false
        },
        preload: {
            type: Object,
            default: null
        }
    },
    async mounted() {
        if (this.preload && this.loaded)
            await this.loaded(this.preload);
        else
            await this.fetch();

        this.loading = false;
    },
    methods: {
        async fetch() {
            this.loading = true;

            const data = (await api("/products/data", { "productId": this.id }));

            if (this.loaded)
                await this.loaded(data);

            this.loading = false;
        },
        async action(name, payload) {
            const req = {
                "productId": this.id,
                "action": name,
                "payload": payload || { }
            };

            return await api("/products/data/action", req);
        }
    },
    watch: {
        $route() {
            this.fetch();
        }
    }
}